import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  Button,
  Row,
  Col,
  Spinner,
  Alert,
} from "reactstrap";
import { Icon } from "../Component";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import FormInput from "../../pages/form-components/InputComponent";
import { ReactTyped } from "react-typed";
import { FormProvider, useForm } from "react-hook-form";
import miscService from "../../api/misc/misc";
import { useDispatch } from "react-redux";
import { setUploadHighlight } from "../../store/slices/misc/highlightSlice";
import supplierApis from "../../api/master/supplier";
import exportFromJSON from "export-from-json";
const  blobUrl:String = process.env.REACT_APP_BLOB_URL||"";
const blobContainer:String= process.env.REACT_APP_BLOB_CONTAINER||"";

const Configuration: any = {
  "suppliers-list": {
    title: "Bulk Suppliers Creation",
    requestType: "supplierCreate",
  },
  "material-list": {
    title: "Bulk Material Creation",
    requestType: "materialCreate",
  },
  stockCreate: {
    title: "Bulk Stock Creation",
    requestType: "stockCreate",
  },
};

const BulkUpload = ({
  showAsButton = true,
  moduleKey,
}: {
  moduleKey?: any;
  showAsButton?: boolean;
}) => {
  const [categories, setCategories] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [materials, setMaterials] = useState<any>([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blockEdit, setBlockEdit] = useState(false);
  const [response, setResponse] = useState({
    status: "",
    message: "",
  });
  const [response2, setResponse2] = useState({
    status: "",
    message: "",
  });
  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = methods;
  const files = watch("attachment");
  const files2 = watch("attachment2");

  useEffect(() => {
    setResponse({ status: "", message: "" });
  }, [files]);

  useEffect(() => {
    setResponse2({ status: "", message: "" });
  }, [files2]);

  const [showModal, setShowModal] = useState(false);

  const fetchCategoryList = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          categoryName: item.category,
          categoryId: item.id.toString(),
        }));
        setCategories(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSiteList = async () => {
    try {
      const { data, status } = await miscService.fetchSitesFiltered();
      if (status) {
        const siteOption = data.map((item: any) => ({
          siteName: item?.name,
          siteId: item?.siteID?.toString(),
        }));
        setSites(siteOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchMaterialList = async () => {
    try {
      const { data, status } = await miscService.fetchProductFiltered();
      if (status) {
        const materialOption = data.map((item: any) => ({
          "Category Name": item?.categoryName,
          materialName: item?.productName,
          materialId: item?.materialID?.toString(),
        }));
        setMaterials(materialOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    switch (moduleKey) {
      case "suppliers-list":
        fetchCategoryList();
        break;
      case "material-list":
        fetchCategoryList();
        fetchSiteList();
        fetchMaterialList();
        break;
      default:
        alert("(Bulk upload useEffect ) Invalid module key " + moduleKey);
    }
  }, [moduleKey]);

  const handleUpload = async (value: any, moduleKey: string) => {
    try {
      switch (moduleKey) {
        case "suppliers-list":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "Supplier File Uploaded Successfully"
          );
          break;
        case "material-list":
          if (value?.attachment?.[0] || value?.attachment2?.[0]) {
            if (value?.attachment?.[0]) {
              await uploadFile(
                value?.attachment,
                moduleKey,
                setResponse,
                "Material File Uploaded Successfully"
              );
            }
            if (value?.attachment2?.[0]) {
              await uploadFile(
                value?.attachment2,
                "stockCreate",
                setResponse2,
                "Stocks File Uploaded Successfully"
              );
            }
          } else {
            setResponse({
              status: "error",
              message: "Please Upload either Material File or Stocks File",
            });
            setBlockEdit(false);
            setLoading(false);
          }

          break;
        default:
          alert("(Bulk upload handleUpload ) Invalid module key " + moduleKey);
      }
    } catch (error) {}
  };

  const uploadFile = async (
    attachment: any,
    moduleKey: string,
    setResponse: any,
    successResponse: any
  ) => {
    try {
      const _file = attachment?.[0];
      const formData: any = new FormData();
      formData.append(
        "filesData",
        JSON.stringify({
          module: "masters",
          requestType: Configuration[moduleKey].requestType,
          action: "Preview",
          reportId: "",
          processedExcelData: {},
        })
      );
      formData.append("files", _file);
      const res = await miscService.bulkUpload(formData);
      const { status, error, message } = res || {};
      if (status) {
        dispatch(setUploadHighlight(true));
        setResponse({
          status: "success",
          message: successResponse,
        });
        return;
      }
      setResponse({
        status: "error",
        message: error,
      });
      setBlockEdit(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const ModalContent = ({ moduleKey }: any) => {
    switch (moduleKey) {
      case "suppliers-list":
        return (
          <>
            <p>
              You're about to create multiple supplier records at once. To
              ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/supplier_bulk_upload.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required supplier data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: categories,
                    fileName: "Categories",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Categories
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each supplier must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  // required
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "material-list":
        return (
          <>
            <p>
              You're about to create multiple material records at once. To
              ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/material_upload_template.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Materials Download Template
              </a>{" "}
              {" / "}
              <a
                href={`${blobUrl}${blobContainer}/stock_upload_template.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Stock Materials Download Template
              </a>{" "}
              and fill in the required material data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: sites,
                    fileName: "Sites",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Sites
              </a>,{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: categories,
                    fileName: "Categories",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Categories 
              </a>{" "}
              and {" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: materials,
                    fileName: "Materials",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each material must have
              unique information to avoid errors during the import process.
            </p>
            <div className="d-flex">
              <Col md={4}>
                {files && files[0]?.name && (
                  <div className="form-group m-0">
                    <div className="form-label-wrapper">
                      <label className="form-label" htmlFor={"attachment"}>
                        Materials File Upload Area
                      </label>
                    </div>
                    <div
                      className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                      style={{ borderRadius: "3px" }}
                    >
                      <span>{files && files[0]?.name}</span>
                      {!blockEdit && (
                        <span
                          onClick={() => {
                            setValue("attachment", null);
                          }}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            display: "block",
                            fontSize: 14,
                          }}
                        >
                          <Icon name="cross"></Icon> &nbsp;
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: `${files && files[0]?.name ? "none" : "block"}`,
                  }}
                >
                  <FormInput
                    type="file"
                    name="attachment"
                    // required
                    label="Materials File Upload Area"
                    placeholder="File Upload Area"
                    accept=".xlsx" // ,.xls,.csv
                  />
                </div>
              </Col>
              <Col md={4} className="ms-3">
                {files2 && files2[0]?.name && (
                  <div className="form-group m-0">
                    <div className="form-label-wrapper">
                      <label className="form-label" htmlFor={"attachment"}>
                        Stock Materials File Upload Area
                      </label>
                    </div>
                    <div
                      className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                      style={{ borderRadius: "3px" }}
                    >
                      <span>{files2 && files2[0]?.name}</span>
                      {!blockEdit && (
                        <span
                          onClick={() => {
                            setValue("attachment2", null);
                          }}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            display: "block",
                            fontSize: 14,
                          }}
                        >
                          <Icon name="cross"></Icon> &nbsp;
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: `${files2 && files2[0]?.name ? "none" : "block"}`,
                  }}
                >
                  <FormInput
                    type="file"
                    // required
                    name="attachment2"
                    label="Stock Materials File Upload Area"
                    placeholder="File Upload Area"
                    accept=".xlsx" // ,.xls,.csv
                  />
                </div>
              </Col>
            </div>
          </>
        );
      default:
        <></>;
    }
    return <></>;
  };

  return (
    <>
      {showAsButton ? (
        <UncontrolledDropdown size={"md"}>
          {" "}
          <div
            onClick={() => {
              setShowModal(true);
            }}
            className="btn btn-white btn-outline-light"
          >
            <Icon name="upload-cloud"></Icon>
            <span>Import</span>
          </div>
        </UncontrolledDropdown>
      ) : (
        <Link
          to={`#`}
          onClick={() => {
            setShowModal(true);
          }}
        >
          <Icon name="upload-cloud"></Icon>
          <span>Upload</span>
        </Link>
      )}
      <Modal
        title={Configuration[moduleKey]?.title}
        open={showModal}
        footer={null}
        onCancel={() => {
          setShowModal(false);
          setBlockEdit(false);
          methods.reset();
          setLoading(false);
          setResponse(() => ({
            status: "",
            message: "",
          }));
        }}
        width={"70%"}
      >
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(async (values) => {
              setResponse(() => ({
                status: "",
                message: "",
              }));
              setResponse2(() => ({
                status: "",
                message: "",
              }));
              setBlockEdit(true);
              setLoading(true);
              handleUpload(values, moduleKey);
            })}
          >
            <ModalContent moduleKey={moduleKey} />
            <Alert
              isOpen={response?.status === "error"}
              color="danger"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <ReactTyped
                strings={[response?.message]}
                typeSpeed={30}
                showCursor={false}
              />
            </Alert>

            <Alert
              isOpen={response?.status === "success"}
              color="success"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <p>
                {response?.message}, Check status in the{" "}
                <span
                  className="inlineTableCellLink"
                  onClick={() => {
                    navigate("/bulk-upload-list", {
                      state: {
                        tab: "Bulk Upload",
                      },
                    });
                  }}
                >
                  Uploads History
                </span>
              </p>
            </Alert>
            <Alert
              isOpen={response2?.status === "error"}
              color="danger"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <ReactTyped
                strings={[response2?.message]}
                typeSpeed={30}
                showCursor={false}
              />
            </Alert>

            <Alert
              isOpen={response2?.status === "success"}
              color="success"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <p>
                {response2?.message}, Check status in the{" "}
                <span
                  className="inlineTableCellLink"
                  onClick={() => {
                    navigate("/bulk-upload-list", {
                      state: {
                        tab: "Bulk Upload",
                      },
                    });
                  }}
                >
                  Uploads History
                </span>
              </p>
            </Alert>

            <Row className="mt-4">
              <Col>
                {response?.status == "success" ||
                response2?.status == "success" ? (
                  <></>
                ) : (
                  <ul className="actions clearfix d-flex">
                    <li>
                      {loading ? (
                        <Button color="primary" type="button" size="md">
                          <Spinner size="sm" color="light" />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          // disabled={
                          //   moduleKey == "material-list"
                          //     ? !files?.[0] || !files2?.[0]
                          //     : !files?.[0]
                          // }
                        >
                          Upload
                        </Button>
                      )}
                    </li>
                    {!loading && (
                      <li className="m-3 mt-0">
                        <Button
                          color="primary"
                          onClick={() => {
                            setShowModal(false);
                            methods.reset();
                          }}
                          className="btn-dim btn btn-secondary"
                        >
                          Cancel
                        </Button>
                      </li>
                    )}
                  </ul>
                )}
              </Col>
            </Row>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

export default BulkUpload;
